import { render, staticRenderFns } from "./OrganizationTransactions.vue?vue&type=template&id=116ceebf&scoped=true"
import script from "./OrganizationTransactions.vue?vue&type=script&lang=js"
export * from "./OrganizationTransactions.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTransactions.vue?vue&type=style&index=0&id=116ceebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ceebf",
  null
  
)

export default component.exports